import React from 'react';
import CuadroDatos from '../UI/CuadroDatos.js';
import MensajeError from '../UI/MensajeError.js';
import styles from './TotalesSeleccionRival.module.css';

const TotalesSeleccionRival = (props) => {
  const { searchTrigger, totalesFiltrados } = props;
  const errores = null;
  const isCargando = searchTrigger !== undefined && typeof totalesFiltrados === 'undefined';
  const totales = totalesFiltrados === undefined ? null : totalesFiltrados;

  return (
    <CuadroDatos titulo="Totales" isCargando={isCargando} errores={errores}>
      {totales ? (
        <table className={styles.tablaTotales}>
          <thead>
            <tr>
              <td className={styles.columnaTitulo} />
              <td className={styles.columnaValor} />
            </tr>
          </thead>
          <tbody>
            <tr className={styles.filaCondicion}>
              <td className={styles.condicion}>Total</td>
              <td className={styles.totalPartidos}>{totales.totalPartidos}</td>
            </tr>
            <tr>
              <td className={styles.filaTitulo}>Ganados</td>
              <td className={styles.filaValor}>{totales.ganados}</td>
            </tr>
            <tr>
              <td className={styles.filaTitulo}>Empates</td>
              <td className={styles.filaValor}>{totales.empatados}</td>
            </tr>
            <tr>
              <td className={styles.filaTitulo}>Perdidos</td>
              <td className={styles.filaValor}>{totales.perdidos}</td>
            </tr>
            <tr>
              <td className={styles.filaTitulo}>Goles a favor</td>
              <td className={styles.filaValor}>{totales.golesAFavor}</td>
            </tr>
            <tr>
              <td className={styles.filaTitulo}>Goles en contra</td>
              <td className={styles.filaValor}>{totales.golesEnContra}</td>
            </tr>
          </tbody>
        </table>
      ) : (
        !isCargando && !errores && <span className={styles.noPartidos}>No se enfrentaron</span>
      )}
      {errores && <MensajeError errores={errores} />}
    </CuadroDatos>
  );
};

export default TotalesSeleccionRival;
